import {
  ActionButtonContainer,
  ActionButton,
} from "components/AgGrid/ActionButton";

import React from "react";

import { faDownload } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import type { SideLoadedBusinessGridContext } from "components/Business/SideLoadedBusinesses/useSideLoadedBusinessGridContext";

interface SideLoadedBusinessActionsRendererProps {
  context: SideLoadedBusinessGridContext;
  data: {
    id: string;
  };
}

export function SideLoadedBusinessActionsRenderer({
  context,
  data,
}: SideLoadedBusinessActionsRendererProps) {
  const { handleSelectAndCompare } = context;
  const { id } = data;

  const handleClick = () => {
    handleSelectAndCompare(id);
  };

  return (
    <ActionButtonContainer>
      <ActionButton onClick={handleClick} data-tour="selectAndCompare">
        <FontAwesomeIcon icon={faDownload} />
        &nbsp;Use
      </ActionButton>
    </ActionButtonContainer>
  );
}
